import script from "./GroupChildView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupChildView.vue?vue&type=script&setup=true&lang=ts"

import "./GroupChildView.vue?vue&type=style&index=0&id=8ac38afe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ac38afe"]])

export default __exports__